export const HTTPS_PREFIX = 'https://';

export const PUBLIC_SITES_URLS = {
  termsAndConditions: '/terms-and-conditions',
  privacyPolicy: '/privacy-policy',
  optOutLoyalty: '/opt-out/loyalty'
};
